module.exports = __webpack_public_path__ + "img/plapla_slider_btn_one.fdd1b84f.png";